import { createRef } from "react";

export class classVeryInputPass {
  // props recibidas
  static propsTemplate = () => ({
    onChangeRefInput: (ref = createRef()) => {},
    CSS: [],
    title: "",
    text: "",
    textError: "",
    placeHolder: "",
    size: { title: 0, text: 0, textError: 0 },
    isDisabled: false,
    isEditable: false,
    isRequired: false,
    onLostFocus: () => {},
    onWonFocus: () => {},
    onEnter: () => {},
    onChangeText: (newText = "") => {},
  });
}
